const IGNORED_LABELS = new Set(["Parts Front", "Parts Back", "Whole"]);

export const sanitizeBodySvg = (svgFile: string) =>
  svgFile
    .replace(/<\?xml[\s\S]*?\?>/gi, "")
    .replace(/<sodipodi:namedview[\s\S]*?\/>/gi, "")
    .replace(/<sodipodi:namedview[\s\S]*?<\/sodipodi:namedview>/gi, "")
    .replace(/<defs[\s\S]*?<\/defs>/gi, "")
    .trim();

export const getPathLabel = (path: Element): string | null => {
  const dataLabel = path.getAttribute("data-label");
  if (dataLabel) return dataLabel;

  for (const name of path.getAttributeNames()) {
    if (name === "inkscape:label" || name.endsWith(":label")) {
      return path.getAttribute(name);
    }
  }

  return null;
};

export const isSelectableBodyPath = (path: Element): boolean => {
  const label = getPathLabel(path);
  return Boolean(label && !IGNORED_LABELS.has(label));
};

export const mountBodySvg = (host: HTMLDivElement, svgMarkup: string) => {
  if (host.dataset.markup === svgMarkup && host.querySelector("svg")) {
    return host.querySelector("svg");
  }

  host.replaceChildren();
  const template = document.createElement("template");
  template.innerHTML = svgMarkup;
  const svg = template.content.querySelector("svg");

  if (!svg) return null;

  svg.setAttribute("width", "100%");
  svg.setAttribute("height", "100%");
  svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
  host.appendChild(svg);
  host.dataset.markup = svgMarkup;

  return svg;
};
